import React, { FC } from 'react';

import { DedicatedRouteProps } from 'home/view/check-feasibility/comp-generator/common-interface';
import AuthView from './auth-view';
import CheckFeasibilityUA from './unauth-view/check-feasibility-ua';

import './index.scss';

interface Props {}

export const CheckFeasibility: FC<DedicatedRouteProps> = (props) => {
  const { isUnAuthJourney } = props;

  const renderCheckFeasibility = () => {
    if (isUnAuthJourney) {
      return <CheckFeasibilityUA {...props} />;
    }

    return <AuthView {...props} />;
  };

  return <div className="check-feasibility-wrapper">{renderCheckFeasibility()}</div>;
};

export default CheckFeasibility;
